import React from 'react';
import { useSelector } from 'react-redux';
import { Flex, Text, View } from '@adobe/react-spectrum';
import { PublishActions } from 'app/stores/publish/actions';
import { getSelectedPlatform } from 'app/stores/publish/selectors';
import { useAppDispatch } from 'app/stores/store';
import { getPlatformTag, isPlatformEnabled, Platforms, PlatformType, } from 'app/views/components/dialogs/publish/platform';
import { Text as CustomText } from 'app/views/components/typography/Text';
import { analytics } from 'app/utils/analytics';
const Colors = {
    dark: { inactive: 'rgb(110, 110, 110)', active: 'white' },
    light: { inactive: 'rgb(179, 179, 179)', active: 'black' },
};
const getPlatformsSortedOnAvailability = () => {
    const initialOrder = new Map(Platforms.map(({ type }, index) => [type, index]));
    const platformAvailability = new Map(Platforms.map(({ type }) => [type, isPlatformEnabled(type)]));
    return Platforms.concat().sort((platform1, platform2) => {
        const { type: type1 } = platform1;
        const { type: type2 } = platform2;
        const availability1 = platformAvailability.get(type1);
        const availability2 = platformAvailability.get(type2);
        if (availability1 === availability2) {
            return initialOrder.get(type1) - initialOrder.get(type2);
        }
        if (availability1) {
            return -1;
        }
        if (availability2) {
            return 1;
        }
        return 0;
    });
};
// eslint-disable-next-line unused-imports/no-unused-vars-ts, no-underscore-dangle
const _NewLabel = () => (React.createElement(View, { position: "absolute", backgroundColor: "green-500", paddingY: "size-25", paddingX: "size-50", borderColor: "green-400", borderWidth: "thin", borderRadius: "regular", right: 0, top: -5, UNSAFE_style: { transform: 'rotate(10deg) scale(0.7)' } },
    React.createElement(CustomText, { size: "XS", color: "static-white" }, "LIVE")));
const WipLabel = () => (React.createElement(View, { position: "absolute", backgroundColor: "red-500", paddingY: "size-25", paddingX: "size-50", borderColor: "red-400", borderWidth: "thin", borderRadius: "regular", right: 0, top: -5, UNSAFE_style: { transform: 'rotate(10deg) scale(0.7)' } },
    React.createElement(CustomText, { size: "XS", color: "static-white" }, "WIP")));
const ItemWrapperStyle = {
    flex: 1,
    position: 'relative',
    cursor: 'pointer',
};
export const PlatformPicker = () => {
    const dispatch = useAppDispatch();
    const platforms = React.useRef(getPlatformsSortedOnAvailability());
    const selectedPlatform = useSelector((state) => getSelectedPlatform(state));
    const scheme = useSelector((state) => state.editor.scheme);
    const setSelectedPlatform = React.useCallback((platform) => {
        const { type } = platform;
        analytics({
            action: 'PublishPlaform:Select',
            label: getPlatformTag(type),
        });
        dispatch(PublishActions.selectPlatform(type));
    }, [dispatch]);
    return (React.createElement(Flex, { direction: "row", marginY: "size-100" }, platforms.current.map(platform => {
        const Icon = platform.icon;
        const isActive = platform.type === selectedPlatform;
        const textColor = (isActive ? Colors[scheme].active : Colors[scheme].inactive);
        const showWipLabel = platform.type !== PlatformType.Annotely &&
            !isPlatformEnabled(platform.type);
        return (React.createElement("div", { "data-test-id": `platform-${getPlatformTag(platform.type)}`, key: platform.name, style: ItemWrapperStyle, onClick: () => setSelectedPlatform(platform) },
            showWipLabel && React.createElement(WipLabel, null),
            React.createElement(Flex, { direction: "column", alignItems: "center" },
                React.createElement(Icon, { width: "2em", height: "2em", fill: isActive
                        ? platform.color
                        : Colors[scheme].inactive }),
                React.createElement(Text, { UNSAFE_style: {
                        color: textColor,
                        textAlign: 'center',
                    } }, platform.name))));
    })));
};
